var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_WriteOffList"),
        width: "740px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view settlement-notice"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
          _c("div", { staticStyle: { width: "100%" } }, [
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      "label-position": "left",
                      inline: true,
                      "label-width": "75px"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { "allow-create": true, no: "1" },
                            model: {
                              value: _vm.filter.officeId,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "officeId", $$v)
                              },
                              expression: "filter.officeId"
                            }
                          },
                          _vm._l(_vm.offices, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.$getLangColumn(item),
                                value: item.officeId
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "tab_BillOverseasSCenter_cancelClearAmount"
                            ]),
                            expression:
                              "$checkPermission(['tab_BillOverseasSCenter_cancelClearAmount'])"
                          }
                        ],
                        attrs: { no: "2" },
                        on: {
                          click: function($event) {
                            return _vm.cacelClearBtn_clickHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelWriteOff")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "410015206",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TotalWriteOffsP")))
          ]),
          _c("span", [_vm._v(_vm._s(_vm.rmbTotal))]),
          _c("span", [_vm._v("Debit:")]),
          _c("span", [_vm._v(_vm._s(_vm.usdTotal))])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }